import { render, staticRenderFns } from "./RewardsEstimation.vue?vue&type=template&id=5d130ac6&"
import script from "./RewardsEstimation.vue?vue&type=script&lang=js&"
export * from "./RewardsEstimation.vue?vue&type=script&lang=js&"
import style0 from "./RewardsEstimation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports